// extracted by mini-css-extract-plugin
export default {"newsListWp":"index_newsListWp_c8Amf","newsImage":"index_newsImage_Wkt-q","newsList":"index_newsList_Ukfrz","news":"index_news_wEmBt","title":"index_title_w6ARy"};